import React from "react";
import ServicesImage from "../../assets/images/doctor-with-patient.png";

const ResidentialCare = () => {
  return (
    <section className="bg-[--light-orange-color] py-10 px-10 mb-[50px] xl:mb-[100px]">
      <div className="max-w-screen-xl mx-auto">
        {/* Responsive Container */}
        <div className="flex flex-col lg:flex-col xl:flex-row xl:items-start gap-10 mb-10 xl:mb-12">
          {/* Left - Text Section */}
          <div className="w-full xl:w-1/2 flex flex-col justify-between h-full font-poppins text-center xl:text-left items-center xl:items-start">
            <div>
              <h4 className="text-[var(--primary-orange-color)] text-[24px] lg:text-[32px] xl:text-[36px] font-semibold mb-2 uppercase">
                 Residential Home - Roselea
              </h4>

              <h2 className="text-[14px] lg:text-[22px] xl:text-[25px] font-semibold text-green mb-6">
                Specialist Support for Complex Needs
              </h2>

              <p className="text-[var(--light-gray-color)] text-[12px] lg:text-[18px] xl:text-[20px] xl:text-justify font-light mb-8">
                Our residential home is designed for individuals with more acute
                and challenging needs. We offer a high level of structure and
                consistency, with a team trained to support behaviours that may
                challenge and complex emotional or mental health needs. Life
                here is centred around stability, trust, and personalised
                routines that help each resident feel secure and valued. We work
                closely with families and professionals to ensure every
                individual receives the right support to thrive.
              </p>
            </div>
          </div>

          {/* Right - Image Section */}
          <div className="w-full xl:w-1/2">
            <img
              src={ServicesImage}
              alt="Services"
              loading="lazy"
              decoding="async"
              fetchpriority="low"
              className="rounded-xl object-cover object-top w-full xl:h-[450px]"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResidentialCare;
